import React, { Component } from 'react';
import Button from '../elements/Button';

class TwoPanel extends Component {
    
    constructor(props) {
        super(props);

        this.state = {
            panels: []
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            this.setState({
                panels: this.props.data
            });
        }
    }
    
    render() {
        const Panels = this.state.panels.map((panel, key) => {
            return (
                <div key={key} className="panel">
                    <div>
                        <h2>{panel.title}</h2>
                        <h4>{panel.subTitle}</h4>
                        <p>{panel.description}</p>
                        {(!panel.url || panel.url == '' ? '' :
                            <Button action={panel.url} image={this.props.buttonImages[key]} alt="" newClass="btn" />
                        )}
                    </div>
                </div>
            );
        });
        
        return (
            <section className="two-panel">
                {Panels}
            </section>
        );
    }
    
}

export default TwoPanel;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/TwoPanel.js